<div class="body" [formGroup]="formGroup">

    <mat-toolbar class="ams-toolbar">
        <button mat-icon-button>
            <mat-icon>add</mat-icon>
        </button>
        <span>Kunde anlegen</span>
        <span class="spacer"></span>
        <span matSuffix>

            <button mat-icon-button *ngIf="!(service.checkerVisible$|async)" (click)="service.setDoubletCheckerVisible(true)" matTooltip="Dubletten anzeigen">
                <mat-icon>manage_search</mat-icon>
            </button>

            <button mat-icon-button color="warn" (click)="close()" matTooltip="Kundenbezeichnung leeren">
                <mat-icon>close</mat-icon>
            </button>

        </span>
    </mat-toolbar>

    <div class="content">

        <app-customer-form class="scrollable-angular-component"></app-customer-form>

    </div>

    <div class="footer">

        <button [disabled]="formGroup.invalid" (click)="saveCustomer()" mat-raised-button color="primary">
            Speichern
        </button>

    </div>

</div>
